(function() {

  function RegMarkService() {
    var div = document.createElement('div');
    div.innerHTML = '&reg;';
    var mark = div.innerHTML;

    function toString() {
        return mark;
    }

    return {
        toString:toString
    };
  }

  /**
   * This filter displays an assignment title given an assignment.
   */
  angular.module('edxComponents')
    .service('regmarkService', [
      RegMarkService
    ]);

})();
